import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import { PaperComponent } from '../../../utils/helper';
import PropTypes from 'prop-types';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import CancelIcon from '@material-ui/icons/Cancel';
import { IconButton } from '@material-ui/core';

ConfirmDialog.propTypes = {
  IsOpen: PropTypes.bool.isRequired,
  Message: PropTypes.string.isRequired,
  OnHandelClick: PropTypes.func.isRequired,
  AgreeText: PropTypes.string,
  DisAgreeText: PropTypes.string,
  Title: PropTypes.string,
  showButtons: PropTypes.bool,
  Messages: PropTypes.any,
  DisableBackgroundClick: PropTypes.bool
};

export default function ConfirmDialog({
  IsOpen,
  Message,
  OnHandelClick,
  Title,
  Messages,
  showButtons = true,
  AgreeText = 'Agree',
  DisAgreeText = 'Disagree',
  DisableBackgroundClick = false
}) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return showButtons === true ? (
    <div>
      <Dialog
        fullScreen={fullScreen}
        open={IsOpen}
        onClose={() => OnHandelClick(false)}
        aria-labelledby="responsive-dialog-title"
        PaperComponent={PaperComponent}
        disableBackdropClick={DisableBackgroundClick}
      >
        <DialogTitle style={{ cursor: 'move' }} id="responsive-dialog-title">
          {Title && Title !== undefined && Title !== null ? Title : 'Confirm'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText className="display-linebreak">{Message}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              OnHandelClick(true);
            }}
            color="primary"
            autoFocus
          >
            {AgreeText}
          </Button>
          <Button
            autoFocus
            onClick={() => OnHandelClick(false)}
            color="primary"
          >
            {DisAgreeText}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  ) : (
    <>
      <div>
        <Dialog
          fullScreen={fullScreen}
          open={IsOpen}
          onClose={() => OnHandelClick(false)}
          aria-labelledby="responsive-dialog-title"
          PaperComponent={PaperComponent}
        >
          <DialogTitle
            style={{
              // cursor: 'move',
              // color: 'white',
              // backgroundColor: '#002f6c'
            }}
            id="responsive-dialog-title"
          >
            {Title}
            <IconButton
              aria-label={'refreshData'}
              size="small"
              style={{ float: 'right' }}
              onClick={() => { OnHandelClick() }
              }
            >
              <HighlightOffIcon />
            </IconButton>
          </DialogTitle>
          {/* <div className="clise-icon">
            <HighlightOffIcon />
          </div> */}
          <DialogContent>
            <DialogContentText>
              <p className="label-content">
                <b className="label-header">User Name:</b> {Messages.userName}
              </p>
              <p className="label-content">
                <b className="label-header">User Email:</b> {Messages.userEmail}
              </p>
              <p className="label-content">
                <b className="label-header">User Role:</b> {Messages.userRole}
              </p>
              <p className="label-content" style={{ lineHeight: '1.1rem' }}>
                <b className="label-header">Service Type Access:</b>{' '}
                {Messages.serviceTypes}
              </p>
              <p className="label-content" style={{ lineHeight: '1.3rem' }}>
                <b className="label-header">Market Access:</b>{' '}
                {Messages.marketAccess}
              </p>
            </DialogContentText>
          </DialogContent>
          {/* <DialogActions>
        <Button onClick={() => { OnHandelClick(true); }} color="primary" autoFocus>
            {AgreeText}
          </Button>
          <Button autoFocus onClick={() => OnHandelClick(false)} color="primary">
            {DisAgreeText}
          </Button>
        </DialogActions> */}
        </Dialog>
      </div>
    </>
  );
}
